/**
 * Canonical list of supported UI locales — the single source of truth for
 * i18next's `supportedLngs` and the in-app language selector. Labels are
 * endonyms (each language written in its own name) so they read the same
 * regardless of the active UI language.
 */
export interface SupportedLocale {
  code: string;
  label: string;
}

export const SUPPORTED_LOCALES: SupportedLocale[] = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt-BR", label: "Português (Brasil)" },
  { code: "ru", label: "Русский" },
  { code: "tr", label: "Türkçe" },
  { code: "ar", label: "العربية" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "zh-CN", label: "简体中文" },
];

export const SUPPORTED_LNGS = SUPPORTED_LOCALES.map((l) => l.code);

/** Locales that render right-to-left. */
export const RTL_LNGS = new Set(["ar"]);

/** Reflect the active language onto `<html lang>` / `<html dir>`. */
export function applyDocumentLanguage(lng: string): void {
  const base = lng.split("-")[0];
  const el = document.documentElement;
  el.lang = lng;
  el.dir = RTL_LNGS.has(base) ? "rtl" : "ltr";
}
